import * as _ from "lodash"

// eslint-disable-next-line complexity -- FIXME psinclair
export function fillDimensionCategories(
  results: Array<any>,
  timeDimension: string,
  measure: string,
  dimensionCategories: Map<string, Array<string>> = new Map<
    string,
    Array<string>
  >()
): Array<any> {
  const completeResults: Array<any> = new Array<any>()
  const resultsByDateDimensionCategory = new Map<string, Map<string, number>>()
  const resultDimensionCategories = new Map<string, Array<string>>()
  const timeDimensionGranularity = `${timeDimension}.month`

  // If dimension/categories are not provided, determine from data
  if (_.isEmpty(dimensionCategories)) {
    dimensionCategories = extrapolateDimensionCategories(
      results,
      timeDimension,
      measure
    )
  }

  // Index results (measure value) by timeDimension and dimension/category
  for (const result of results) {
    if (!resultsByDateDimensionCategory.has(result[timeDimensionGranularity])) {
      resultsByDateDimensionCategory.set(
        result[timeDimensionGranularity],
        new Map<string, number>()
      )
    }
    let dimensionCategoryKey = ""
    for (const [dimension, categories] of dimensionCategories) {
      if (_.has(result, dimension)) {
        resultDimensionCategories.set(dimension, categories)
        const resultDimension = <string>result[dimension]
        dimensionCategoryKey += `,${dimension}=${resultDimension}`
      }
    }
    resultsByDateDimensionCategory
      .get(result[timeDimensionGranularity])!
      .set(dimensionCategoryKey, result[measure])
  }

  // Generate all possible indexes (dimension/category combinations)
  for (const [timeDimensionKey, values] of resultsByDateDimensionCategory) {
    const combinations = dimensionCategoryCombinations(
      resultDimensionCategories
    )

    const workingDimensionCategories = _.cloneDeep(resultDimensionCategories)
    const dimensionCategoryHistory = new Array<Array<string>>()

    for (let i = 0; i < combinations; i++) {
      let dimensionCategoryKey = ""
      for (const [dimension, categories] of workingDimensionCategories) {
        dimensionCategoryHistory.push([dimension, categories[0]])
        dimensionCategoryKey += `,${dimension}=${categories[0]}`
      }

      // Build result from index with existing or defaulted value
      completeResults.push(
        buildResult(
          dimensionCategoryKey,
          timeDimensionKey,
          timeDimensionGranularity,
          measure,
          values
        )
      )

      // Manipulate dimension/categories to control structure
      processDimensionCategories(
        dimensionCategoryHistory,
        workingDimensionCategories,
        resultDimensionCategories
      )
    }
  }

  return completeResults
}

function sortDimensionCategories(
  dimensionCategories: Map<string, Array<string>>
) {
  for (const dimension of dimensionCategories.keys()) {
    dimensionCategories.get(dimension)!.sort()
  }
}

function extrapolateDimensionCategories(
  results: Array<any>,
  timeDimension: string,
  measure: string
): Map<string, Array<string>> {
  const dimensionCategories: Map<string, Array<string>> = new Map<
    string,
    Array<string>
  >()

  for (const result of results) {
    for (const property of Object.keys(result)) {
      if (!property.startsWith(timeDimension) && property !== measure) {
        /* eslint-disable max-depth -- TODO simplify this */
        if (!dimensionCategories.has(property)) {
          dimensionCategories.set(property, new Array<string>())
        }

        if (!dimensionCategories.get(property)!.includes(result[property])) {
          dimensionCategories.get(property)!.push(result[property])
        }
        /* eslint-enable max-depth */
      }
    }
  }

  sortDimensionCategories(dimensionCategories)

  return dimensionCategories
}

function dimensionCategoryCombinations(
  dimensionCategories: Map<string, Array<string>>
): number {
  let combinations = 1
  for (const dimension of dimensionCategories.keys()) {
    combinations *= dimensionCategories.get(dimension)!.length
  }

  return combinations
}

function removeDimensionCategory(
  dimension: string,
  category: string,
  categories: Map<string, Array<string>>
) {
  categories
    .get(dimension)!
    .splice(categories.get(dimension)!.indexOf(category), 1)
}

function processDimensionCategories(
  dimensionCategoryHistory: Array<Array<string>>,
  workingDimensionCategories: Map<string, Array<string>>,
  dimensionCategories: Map<string, Array<string>>
) {
  const dimensionCategory = dimensionCategoryHistory.pop()

  if (dimensionCategory) {
    removeDimensionCategory(
      dimensionCategory[0],
      dimensionCategory[1],
      workingDimensionCategories
    )

    if (workingDimensionCategories.get(dimensionCategory[0])!.length === 0) {
      workingDimensionCategories.set(
        dimensionCategory[0],
        _.cloneDeep(dimensionCategories.get(dimensionCategory[0]))!
      )
      processDimensionCategories(
        dimensionCategoryHistory,
        workingDimensionCategories,
        dimensionCategories
      )
    }
  }
}

function buildResult(
  dimensionCategoryKey: string,
  timeDimensionKey: string,
  timeDimensionGranularity: string,
  measure: string,
  values: Map<string, number>
) {
  let measureValue = 0
  if (values.has(dimensionCategoryKey)) {
    measureValue = values.get(dimensionCategoryKey)!
  }

  const result: any = {}

  // extract dimension categories from key
  dimensionCategoryKey = dimensionCategoryKey.replace(",", "")
  for (const dimensionCategory of dimensionCategoryKey.split(",")) {
    const dimensionCategoryTokens = dimensionCategory.split("=")
    result[dimensionCategoryTokens[0]] = dimensionCategoryTokens[1]
  }

  result[timeDimensionGranularity] = timeDimensionKey
  result[measure] = measureValue

  return result
}
